module.exports = __webpack_public_path__ + "static/img/svip_zh_title.17aa7506.png";